import React from 'react';

import { Box, Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';

import { trackClick } from '../features/track';
import Footer from '../Shared/components/Footer';
import { urlBuilder } from '../Shared/urlBuilder';

const InvitationLoadingError: React.FC = () => {
  return (
    <CenteredWorkflowLayout title="Joint Checking signup">
      <CenteredWorkflowLayout.Slot name="content">
        <Box
          css={{
            marginBottom: 'space.300',
          }}
        >
          <Icon name="ExclamationCircle" size="large" color="icon" />
        </Box>
        <Heading as="h1" variant="primary">
          Something went wrong
        </Heading>
        <Box
          css={{
            marginBottom: 'space.400',
          }}
        >
          <Text as="p">We had trouble loading your invite - please try again.</Text>
        </Box>
        <CenteredWorkflowLayout.Actions>
          <SambaAutoLink
            onClick={() => trackClick({ name: 'GotIt', flow: 'SecondaryAcceptJCInvite' })}
            to={urlBuilder.appHome.absolute()}
            variant="solidPrimary"
          >
            Got it
          </SambaAutoLink>
        </CenteredWorkflowLayout.Actions>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default InvitationLoadingError;
